<template>
<div class="notes-list-class">
    <b-modal :id="modalId" title="Text Messages" hide-footer>
        <span v-if="numberType == 'phoneNumber'">
            <b>Phone Number: </b>{{patient.phoneNumber}}
        </span>
        <span v-if="numberType == 'cellNumber'">
            <b>Cell Number: </b>{{patient.cellNumber}}
        </span>
        <div v-if="!isLoading">
            <div v-if="messages && messages.length" >
                <b-row v-for="msg in messages" :key="msg.textMessageDate" class="m-3 border">
                    <b-col>
                        <b>{{ msg.textMessageStatus }}: </b>
                        <i>{{ getFormattedDate(msg.textMessageDate) }}:</i>
                        <div>
                            {{ msg.textMessageBody }}
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div v-else>
                {{emptyText}}
            </div>
        </div>
        <div v-else>
            <b-spinner label="Spinning" class="mr-2"></b-spinner>
            <strong>Loading...</strong>
        </div>
    </b-modal>
</div>
</template>

<script lang="ts">

import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';
import { TextData } from '@/models/TextData';
import { Patient } from '@/models/Patient';
import axios, {AxiosError} from 'axios';
import moment from "moment";
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: "TextMessagesList"
})
export default class TextMessagesList extends Vue {
    @Prop({default: "No text messages found."}) private emptyText!: string;
    @Prop({default: "text-message-modal"}) private modalId! : string;
    @Prop({default: ""}) private patient!: Patient;
    
    private numberType:string = "";
    private messages: Array<TextData> = new Array<TextData>();
    private isLoading: boolean = false;

    openModal(numberType:string){
        if(!(this.patient?.id && numberType)) return;

        this.$bvModal.show('text-message-modal');
        this.numberType = numberType;
        this.isLoading = true
        axios.get<Array<TextData>>(`/Patient/${this.patient.id}/text-message-history/${numberType}`)
            .then(response => {
                this.messages = response.data;
            }).catch((error:AxiosError) => {
                this.$notification(NotificationOptions.error(error));
                console.log("Error getting text message history", {error, response: error?.response});
            }).finally(() => {
                this.isLoading = false;
            });
    }
    
    get patientNumber():string {
        if(this.numberType == 'phoneNumber') return this.patient.cellNumber;
        else if(this.numberType == 'cellNumber') return this.patient.phoneNumber;
        else return '';
    }

    getFormattedDate(value : Date) {
        return moment.utc(value).local().format("lll");
    }
    
}
</script>
